// Rutas de admin
import Dashboard from '../controllers/admin/dashboard.vue'

// Sistema
import Roles from '../controllers/admin/sistema/roles.vue'
import Usuarios from '../controllers/admin/sistema/usuarios.vue'
import Alertas from '../controllers/admin/sistema/alertas.vue'

// Encuestas
import LanzarEncuestas from '../controllers/admin/encuestas/LanzarEncuestas.vue'
import Caracterizaciones from '../controllers/admin/encuestas/caracterizaciones.vue'
import Periodicas from '../controllers/admin/encuestas/periodicas.vue'
import Dinamicas from '../controllers/admin/encuestas/dinamicas.vue'
import Grupos from '../controllers/admin/encuestas/dinamicas.grupos.vue'
import Preguntas from '../controllers/admin/encuestas/dinamicas.preguntas.vue'
import Respuestas from '../controllers/admin/encuestas/dinamicas.respuestas.vue'

// Autorizaciones
import Autorizaciones from '../controllers/admin/autorizaciones/autorizaciones.vue'
import SolicitudesAutorizacion from '../controllers/admin/autorizaciones/solicitudesAutorizacion.vue'
import SolicitudesDesautorizacion from '../controllers/admin/autorizaciones/solicitudesDesautorizacion.vue'
import ValidacionSolicitudes from '../controllers/admin/autorizaciones/validacionSolicitudes.vue'


// Control acceso
import RegistroEntrada from '../controllers/admin/controlAcceso/RegistroEntrada.vue'
import RegistroSalida from '../controllers/admin/controlAcceso/RegistroSalida.vue'
import AjustesControlAcceso from '../controllers/admin/controlAcceso/ajustesControlAcceso.vue'

export default [
  {
    path: '',
    name: 'dashboard',
    component: Dashboard,
  },

  // Sistema
  {
    path: 'roles',
    name: 'roles',
    component: Roles,
  },
  {
    path: 'usuarios',
    name: 'usuarios',
    component: Usuarios,
  },

  // Caracterizaciones
  {
    path: 'caracterizaciones',
    name: 'caracterizaciones',
    component: Caracterizaciones,
  },

  // Periódicas
  {
    path: 'periodicas',
    name: 'periodicas',
    component: Periodicas,
  },

  // Dinámicas
  {
    path: 'dinamicas',
    name: 'dinamicas',
    component: Dinamicas,
  },
  {
    path: 'dinamicas/:id/preguntas',
    name: 'dinamicas.preguntas',
    component: Preguntas,
  },
  {
    path: 'dinamicas/:id/grupos',
    name: 'dinamicas.grupos',
    component: Grupos,
  },
  {
    path: 'dinamicas/:id/respuestas',
    name: 'dinamicas.respuestas',
    component: Respuestas,
  },

  // Autorizaciones
  {
    path: 'autorizaciones',
    name: 'autorizaciones',
    component: Autorizaciones,
  },
  {
    path: 'autorizaciones-solicitar',
    name: 'autorizaciones-solicitar',
    component: SolicitudesAutorizacion,
  },
  {
    path: 'desautorizaciones-solicitar',
    name: 'desautorizaciones-solicitar',
    component: SolicitudesDesautorizacion,
  },
  {
    path: 'validacion-solicitudes',
    name: 'validacion-solicitudes',
    component: ValidacionSolicitudes,
  },

  // Control de acceso
  {
    path: 'lanzar-encuestas',
    name: 'lanzar-encuestas',
    component: LanzarEncuestas,
  },
  {
    path: 'alertas',
    name: 'alertas',
    component: Alertas,
  },
  {
    path: 'registro-entrada',
    name: 'registro-entrada',
    component: RegistroEntrada,
  },
  {
    path: 'registro-salida',
    name: 'registro-salida',
    component: RegistroSalida,
  },

  // Ajustes
  {
    path: 'ajustes-control-acceso',
    name: 'ajustes-control-acceso',
    component: AjustesControlAcceso,
  },
]
